/* Auto generated by gulp-typescript-template */

export const IFrame = `<div class="IFrame content-margin"><iframe class="i-frame [[ url ? '' : '-hidden' ]]" alt="[[caption]]" title="[[caption]]" frameborder="0"></iframe><div class="caption [[ caption ? '' : '-hidden' ]]">[[caption]]</div></div>`;
